import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Mail, Globe, MapPin, ArrowUp } from "lucide-react";
import { brand, contactInfo, navLinks } from "../mock";

export default function Footer() {
  const navigate = useNavigate();

  const go = (l) => {
    if (l.type === "route") { navigate(l.to); window.scrollTo({ top: 0 }); return; }
    navigate("/");
    setTimeout(() => {
      if (l.target === "top") window.scrollTo({ top: 0, behavior: "smooth" });
      else document.getElementById(l.target)?.scrollIntoView({ behavior: "smooth" });
    }, 380);
  };

  return (
    <footer className="bg-[var(--navy-900)] text-cream" style={{ backgroundColor: "var(--navy-900)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.3fr_1fr_1.2fr] gap-14 pb-16 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="bg-cream inline-block rounded-sm p-3 mb-6" style={{ backgroundColor: "var(--cream)" }}>
              <img src={brand.logo} alt="South Sea Design Studio" className="h-20 w-auto object-contain" />
            </div>
            <p className="font-serif-display text-2xl leading-snug text-cream/90 max-w-sm" style={{ color: "rgba(246,243,238,0.9)" }}>
              Thoughtful design. Quality execution. Spaces that work, inspire and last.
            </p>
            <div className="flex gap-5 mt-8">
              {brand.pillars.map((p) => (
                <span key={p} className="font-sans-ui tracking-wide-3 text-[0.62rem] uppercase" style={{ color: "var(--sand)" }}>{p}</span>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <p className="font-sans-ui tracking-wide-2 text-[0.62rem] uppercase mb-6" style={{ color: "var(--teal-light)" }}>Explore</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <button onClick={() => go(l)} className="link-underline font-sans-ui text-sm text-cream/80" style={{ color: "rgba(246,243,238,0.8)" }}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-sans-ui tracking-wide-2 text-[0.62rem] uppercase mb-6" style={{ color: "var(--teal-light)" }}>Get in touch</p>
            <ul className="space-y-4 text-sm text-cream/85" style={{ color: "rgba(246,243,238,0.85)" }}>
              <li className="flex items-center gap-3"><Phone size={15} strokeWidth={1.5} style={{ color: "var(--sand)" }} /> {contactInfo.phone}</li>
              <li className="flex items-center gap-3"><Mail size={15} strokeWidth={1.5} style={{ color: "var(--sand)" }} /> {contactInfo.email}</li>
              <li className="flex items-center gap-3"><Globe size={15} strokeWidth={1.5} style={{ color: "var(--sand)" }} /> {contactInfo.website}</li>
              <li className="flex items-center gap-3"><MapPin size={15} strokeWidth={1.5} style={{ color: "var(--sand)" }} /> {contactInfo.location}</li>
            </ul>
            <p className="mt-6 font-sans-ui tracking-wide-3 text-[0.6rem] uppercase text-cream/45" style={{ color: "rgba(246,243,238,0.45)" }}>
              GSTIN {contactInfo.gstin}
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8">
          <p className="font-script text-2xl" style={{ color: "var(--teal-light)" }}>Let's build extraordinary spaces together</p>
          <div className="flex items-center gap-8">
            <p className="text-cream/45 text-xs font-sans-ui tracking-wide-3" style={{ color: "rgba(246,243,238,0.45)" }}>
              &copy; {new Date().getFullYear()} South Sea Design Studio
            </p>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="flex items-center gap-2 font-sans-ui tracking-wide-3 text-[0.62rem] uppercase text-cream/70 hover:text-cream transition-colors"
              style={{ color: "rgba(246,243,238,0.7)" }}
            >
              Back to top <ArrowUp size={14} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
